import React, { useEffect, useState, useCallback } from "react"
import config, { getBasicAuthHeaders } from "utils/configAdapter"
import { connect } from "react-redux"
import * as Icons from "@ant-design/icons"
import BreadcrumbAdapter from "components/adapters/BreadcrumbAdapter"
import { mask, getColumnSearchProps } from "utils/helpers"
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import {
    Space,
    Row,
    Col,
    Form,
    Input,
    Table,
    Button,
    Select,
    message,
    Divider,
    Typography,
    DatePicker,
    Spin,
    Card,
} from "antd"
import ptBR from 'antd/es/date-picker/locale/pt_BR'

dayjs.extend(customParseFormat)
dayjs.locale('pt-br')

// Removed: const _initToken = localStorage.getItem("authUser")

const Adicionais = props => {
    const { RangePicker } = DatePicker
    const [loading, setLoading] = useState(false)
    const [dataSource, setDataSource] = useState([])
    const [dataTotal, setDataTotal] = useState([])
    const [dataTotalAdic, setDataTotalAdic] = useState([])
    const [adic, setAdic] = useState([])
    const [entidadesList, setEntidadesList] = useState([])
    const [entidadesArr, setEntidadesArr] = useState([])
    const [adicArr, setAdicArr] = useState([])
    const [aderiu, setAderiu] = useState("sim")
    const [tab, setTab] = useState("item-4")

    const [paramsEXCEL, setParamsEXCEL] = useState("")

    const [form] = Form.useForm()
    const FormItem = Form.Item
    const { Option } = Select
    const { Title, Text } = Typography

    const getEntidadesList = useCallback(async () => {
        try {
            let response = await fetch(
                config[process.env.NODE_ENV].url +
                "/adicionais/relatorios/pagamentos-entidade",
                {
                    method: "GET",
                    headers: new Headers(getBasicAuthHeaders()),
                }
            )

            response = await response.json()

            response = response.content.map(v => {
                return {
                    label: v.razao_entd,
                    value: v.cnpj_entd,
                }
            })

            response = response.sort((a, b) => a.label.localeCompare(b.label))

            // response.unshift({
            //     label: "SELECIONA UMA ENTIDADE",
            //     value: ""
            // })

            setEntidadesList(response)
        } catch (e) { }
    })

    useEffect(() => {
        // setAdicArr([])
        getAdicList()
        inicialDates()
    }, [entidadesArr])

    const inicialDates = () => {
        let d = new Date()
        let dini = new Date(d.getFullYear(), d.getMonth(), 1)
        let dfim = new Date(dini.getFullYear(), dini.getMonth() + 1, 0)
        let params = {
            date: [dayjs(dini), dayjs(dfim)],
        }
        form.setFieldsValue(params)
    }

    useEffect(() => {
        getEntidadesList()
        getAdicList()
        if (window.location.search) {
            let URLparams = {}
            window.location.search
                .replace("?", "")
                .split("&")
                .map(e => {
                    e = e.split("=")
                    Object.assign(URLparams, { [e[0]]: e[1] })
                })
            if (URLparams.t) {
                switch (URLparams.t) {
                    case "trabalhadores":
                        setTab("item-2")
                        break
                    case "relatorio":
                        setTab("item-3")
                        break
                }
            }
            // if(URLparams.t){ URLparams.empresa_pesquisa = URLparams.s }
            // let params = { tipo:'sim', /*default*/ ...URLparams }
            // form.setFieldsValue(params)
            // if(Object.keys(URLparams).length) callSearchForm(params)
        }
    }, [])
    const getAdicList = async () => {
        try {
            let params = "?"

            if (entidadesArr.length) {
                params += "entidades=" + entidadesArr.join(",")
            }

            let result = await fetch(
                config[process.env.NODE_ENV].url +
                `/empresa/relatorios/helper/adicional_list${params}`,
                {
                    method: "GET",
                    headers: getBasicAuthHeaders(),
                }
            )

            if (!result.ok) {
                throw await result.json()
            }

            result = await result.json()

            if (result.content) {
                result = result.content.map((e, k) => {
                    return {
                        value: `${e.id_adic}`,
                        label: e.nome_adic,
                    }
                })

                // result.unshift(
                //     {
                //         value: '0',
                //         label: <b>Não Obtantes</b>,
                //     }
                // )
            }

            setAdic(result)
        } catch (e) {
            //mensagem de erro
            if (e.hasOwnProperty("message")) {
                message.error(e.message)
            } else {
                message.error("Erro em executar a chamada.")
            }
        }
    }

    const callSearchForm = async data => {
        try {
            let params = JSON.parse(JSON.stringify(data)) //clear null

            if (adicArr.length === 0) {
                throw await { message: "Informe o adicional" }
            }

            if (!params.date) {
                throw await { message: "Informe a data inicial e final" }
            }

            params.dt_ini = dayjs(
                params.date[0] ? params.date[0] : null
            ).format("YYYY-MM-DD")
            params.dt_fim = dayjs(
                params.date[1] ? params.date[1] : null
            ).format("YYYY-MM-DD")
            delete params.date

            let searchParams = new URLSearchParams(params)
            searchParams = searchParams.toString()
            setParamsEXCEL(searchParams)

            setLoading(true)

            let result = await fetch(
                config[process.env.NODE_ENV].url +
                `/adicionais/relatorios/pagamentos?${searchParams}`,
                {
                    method: "GET",
                    headers: new Headers(getBasicAuthHeaders()),
                }
            )

            if (!result.ok) {
                throw await result.json()
            }

            result = await result.json()

            // console.log(result)

            //data da tabela
            setDataTotal(result.total_blto)
            setDataTotalAdic(result.total_adic)
            setDataSource(result.content)
        } catch (e) {
            //mensagem de erro
            if (e.hasOwnProperty("message")) {
                message.error(e.message)
            } else {
                message.error("Erro em executar a chamada.")
            }
        } finally {
            setLoading(false)
        }
    }

    const downloadExcelBlob = async url => {
        try {
            const token = props.user.token
            let resp = await fetch(url, {
                method: "GET",
                headers: new Headers(getBasicAuthHeaders()),
            })

            resp = await resp.blob()

            if (!resp.message) {
                let url = window.URL.createObjectURL(resp)
                let a = document.createElement("a")
                a.href = encodeURI(url)
                a.download = "RELATORIO_ADIC.xlsx"
                document.body.appendChild(a) // we need to append the element to the dom -> otherwise it will not work in firefox
                a.click()
                a.remove()
            } else {
                message.error(resp.message)
            }
        } catch (e) {
            message.error("Erro na chamada de arquivo")
        }
    }

    const formSearch = () => {
        return (
            <Form layout="vertical" form={form} onFinish={callSearchForm}>
                <Row gutter={5} justify={"space-around"}>
                    {/* ROW */}
                    <Col sm={24} md={24} lg={24}>
                        <FormItem name="entidade" label="Entidade">
                            <Select
                                mode="multiple"
                                placeholder="Selecione uma Entidade"
                                options={entidadesList}
                                onChange={vls => {
                                    setEntidadesArr(vls)
                                }}
                            />
                        </FormItem>
                    </Col>

                    <Col sm={24} md={24} lg={24}>
                        <FormItem name="adic" label="Adicional">
                            <Select
                                mode="multiple"
                                placeholder="Selecione"
                                options={adic}
                                onChange={vls => {
                                    setAdicArr(vls)
                                }}
                            />
                        </FormItem>
                    </Col>

                    <Col sm={24} md={12} lg={12}>
                        <FormItem name="date" label="Data">
                            <RangePicker
                                locale={ptBR}
                                style={{ width: "100%" }}
                                showToday={true}
                                format="DD/MM/YYYY"
                            />
                        </FormItem>
                    </Col>

                    <Col sm={24} md={12} lg={12}>
                        <FormItem
                            name="empresa_pesquisa"
                            label="Razão Social/Nome ou CNPJ/CPF"
                        >
                            <Input placeholder={"Busca"} />
                        </FormItem>
                    </Col>

                    {/* ROW */}

                    <Col sm={24} md={24} lg={24} align="right">
                        <div style={{ marginTop: 55, display: "inline-block" }}>
                            {paramsEXCEL ? (
                                <a
                                    style={{ paddingRight: "10px" }}
                                    href={"#"}
                                    onClick={() =>
                                        downloadExcelBlob(
                                            `${config[process.env.NODE_ENV].url
                                            }/adicionais/relatorios/pagamentos?${paramsEXCEL}&excel=true`
                                        )
                                    }
                                >
                                    <Button type="button'">
                                        Download XLSX
                                    </Button>
                                </a>
                            ) : (
                                ""
                            )}
                            <Button htmlType={"submit"}>Buscar</Button>
                            <Button
                                type="ghost"
                                onClick={() => {
                                    form.resetFields()
                                    setEntidadesArr([])
                                    setAdicArr([])
                                }}
                            >
                                Limpar Busca
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Form>
        )
    }

    const [pageSize, setPageSize] = useState(20)
    let columnsBase = [
        {
            title: <small>CNPJ/CPF</small>,
            dataIndex: "cnpj_empr",
            key: "cnpj",
            width: 155,
            sorter: (a, b) => a.cnpj_empr - b.cnpj_empr,
            ...getColumnSearchProps("cnpj_empr", "number"),
            render: (data, row) => {
                return (
                    <>
                        <Typography.Text
                            copyable={{
                                text: data,
                                icon: [
                                    <Icons.CopyFilled />,
                                    <Icons.CopyOutlined />,
                                ],
                                tooltips: ["Copiar", "Copiado!"],
                            }}
                        >
                            {mask(data)}
                        </Typography.Text>{" "}
                    </>
                )
            },
        },
        {
            title: <small>Empregador</small>,
            dataIndex: "razao_empr",
            ...getColumnSearchProps("razao_empr"),
            sorter: (a, b) =>
                a.razao_empr.trim().localeCompare(b.razao_empr.trim()),
            key: "razao",
        },
        {
            title: (
                <small>
                    Data
                    <br />
                    pagto.
                </small>
            ),
            dataIndex: "dt_pgto_empr_blto",
            ...getColumnSearchProps("dt_pgto_empr_blto", "RangePicker"),
            sorter: (a, b) =>
                dayjs(a.dt_pgto_empr_blto).valueOf() -
                dayjs(b.dt_pgto_empr_blto).valueOf(),
            key: "dt_boleto",
            width: 100,
            render: (data, row) => {
                return data ? mask(data, "date") : "-"
            },
        },
        {
            title: (
                <small>
                    Valor
                    <br />
                    Boleto
                </small>
            ),
            dataIndex: "vlr_pago_empr_blto",
            key: "vl_blto",
            width: 155,
            sorter: (a, b) => a.vlr_pago_empr_blto - b.vlr_pago_empr_blto,
            ...getColumnSearchProps("vlr_pago_empr_blto", "number"),
            render: (data, row) => {
                return mask(data, "currency")
            },
        },
        {
            title: (
                <small>
                    Valor
                    <br />
                    Adicional
                </small>
            ),
            dataIndex: "vlr_adic_empr_blto",
            key: "vl_adic",
            width: 155,
            sorter: (a, b) => a.vlr_adic_empr_blto - b.vlr_adic_empr_blto,
            ...getColumnSearchProps("vlr_adic_empr_blto", "number"),
            render: (data, row) => {
                return mask(data, "currency")
            },
        },
        {
            title: <small>Parcela</small>,
            dataIndex: "parcela",
            key: "parcela",
            width: 155,
            // render: (data, row) => {
            //     return
            // }
        },
    ]
    const [columns, setColumns] = useState(columnsBase)
    const tableContent = () => {
        return (
            <Row>
                <Col sm={24} md={24} lg={24}>
                    <Table
                        summary={pageData => {
                            if (!dataSource.length) {
                                return <></>
                            }
                            return (
                                <>
                                    <Table.Summary.Row>
                                        <Table.Summary.Cell colSpan={99}>
                                            <Row justify={"space-around"}>
                                                <Col span={6}>
                                                    Número empregadores:{" "}
                                                    <b>{dataSource.length}</b>
                                                </Col>
                                                <Col span={6} align="right">
                                                    Valor total boletos :{" "}
                                                    <b>
                                                        {mask(
                                                            dataTotal,
                                                            "currency"
                                                        )}
                                                    </b>
                                                </Col>
                                                <Col span={6} align="right">
                                                    Valor total adicional:{" "}
                                                    <b>
                                                        {mask(
                                                            dataTotalAdic,
                                                            "currency"
                                                        )}
                                                    </b>
                                                </Col>
                                                {/* <Col span={6} align='right'>
                                            Diferença: <b>{mask(dataTotal - dataTotalAdic, 'currency')}</b>
                                        </Col> */}
                                            </Row>
                                        </Table.Summary.Cell>
                                    </Table.Summary.Row>
                                </>
                            )
                        }}
                        rowKey={"id_empr"}
                        columns={columns}
                        scroll={{ x: 400 }}
                        dataSource={dataSource}
                        pagination={{
                            // showTotal:() => <span>Total <b>{dataSource.length}</b> empregadores</span>,
                            pageSize: pageSize,
                            pageSizeOptions: [20, 50, 100],
                            onShowSizeChange: (current, pageSize) => {
                                // console.log(current, pageSize);
                                setPageSize(pageSize)
                            },
                        }}
                    />
                </Col>
            </Row>
        )
    }

    const consultaPagamentoRender = () => {
        return (
            <>
                <Row>
                    <Col span={18}>
                        <BreadcrumbAdapter
                            data={[
                                { titulo: "Adicionais", link: "/" },
                                { titulo: "Pagamentos" },
                            ]}
                        />
                    </Col>
                    <Col span={6} align="right"></Col>
                </Row>
                <Space />
                <Spin spinning={loading}>
                    {formSearch()}

                    <Divider />

                    {loading ? <></> : tableContent()}
                </Spin>
            </>
        )
    }

    return (
        <>
            <Row>
                <Col span={24}>
                    <BreadcrumbAdapter
                        data={[
                            { titulo: "Adicionais", link: "/" },
                            { titulo: "Relatório Pagamentos" },
                        ]}
                    />
                </Col>
            </Row>

            {/* Header Section */}
            <Card
                style={{ marginBottom: 24 }}
                bodyStyle={{ padding: "20px 24px" }}
            >
                <Row align="middle" justify="space-between">
                    <Col>
                        <Title
                            level={2}
                            style={{ margin: 0, color: "#1890ff" }}
                        >
                            <Icons.DollarOutlined style={{ marginRight: 8 }} />
                            Consulta de Pagamentos
                        </Title>
                        <Text type="secondary" style={{ fontSize: "14px" }}>
                            Consulte os pagamentos realizados pelos adicionais, com filtros por entidade, adicional e período de datas.
                        </Text>
                    </Col>
                </Row>
            </Card>

            <Spin spinning={loading}>
                {formSearch()}

                <Divider />

                {loading ? <></> : tableContent()}
            </Spin>
        </>
    )
}

const mapStateToProps = state => {
    return {
        user: state.user,
    }
}

export default connect(mapStateToProps)(Adicionais)
